<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="members">
    <h1 class="font-weight-thin display-1 grey--text ml-3 mt-3 hidden-xs-only">
      Team Members
    </h1>
    <div class="ml-3 my-3 mr-3">
      <div class="pa-2 rounded-card" style="background-color: white;">
        <v-toolbar flat color="white">
          <v-toolbar-title class="mt-3"
            ><span class="primary--text text-lighten-2">Team Members </span
            ><span
              v-if="isTeamOwner"
              class="primary--text text-lighten-2 font-weight-thin"
              >{{ userCount }}</span
            ></v-toolbar-title
          >
          <v-spacer></v-spacer>
          <Invite v-if="isTeamOwner && ihasusers">Invite</Invite>
          <v-btn
            v-if="isTeamOwner && !ihasusers"
            flat
            outline
            color="primary"
            @click="updateNotice"
            ><v-icon small>add</v-icon>Invite</v-btn
          >
        </v-toolbar>
        <v-data-table
          :headers="computedHeaders"
          :items="users"
          item-key="_id"
          :expand="expand"
          class="ml-4 mr-4"
        >
          <template v-slot:items="props">
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div
                style="align-items: center; display: flex; white-space: nowrap; justify-content: left;"
              >
                <Avatar
                  :username="makeName(props.item)"
                  :src="props.item.avatar"
                  :size="$options.avatarTool"
                  class="mr-2"
                ></Avatar>
                <span class="mr-2">{{ makeName(props.item) }}</span>
                <v-chip
                  v-if="isYou(props.item._id)"
                  small
                  color="success"
                  text-color="white"
                >
                  You</v-chip
                >
                <v-chip
                  v-if="isATeamOwner(props.item._id)"
                  small
                  color="info"
                  text-color="white"
                >
                  Owner</v-chip
                >
              </div>
            </td>
            <td
              class="text-xs-right"
              v-if="!$vuetify.breakpoint.smAndDown"
              @click="props.expanded = !props.expanded"
            >
              <span>{{ props.item.email }}</span>
            </td>
            <td
              class="text-xs-right"
              v-if="!$vuetify.breakpoint.smAndDown"
              @click="props.expanded = !props.expanded"
            >
              <span>{{ props.item.mobile }}</span>
            </td>
            <td
              class="text-xs-right"
              v-if="!$vuetify.breakpoint.smAndDown"
              @click="props.expanded = !props.expanded"
            >
              {{ formatDate(props.item.lastLogin) }}
            </td>
            <td
              class="justify-center align-center layout px-0"
              v-if="!$vuetify.breakpoint.smAndDown"
            >
              <EditMember
                v-if="isTeamOwner || isYou(props.item._id)"
                :member="props.item"
              ></EditMember>
              <v-btn v-else icon disabled>
                <v-icon small>edit</v-icon>
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="
                      isTeamOwner &&
                        !isYou(props.item._id) &&
                        !isATeamOwner(props.item._id)
                    "
                    icon
                    flat
                    class="ml-0"
                    color="primary"
                    v-on="on"
                    @click="deleteMember(props.item)"
                  >
                    <v-icon small>
                      delete
                    </v-icon>
                  </v-btn>
                  <v-btn v-else icon class="ml-0" disabled>
                    <v-icon small>
                      delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Remove member from team</span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:expand="props">
            <div class="grey lighten-3">
              <v-card flat>
                <v-container fluid grid-list-md>
                  <v-card color="white" class="rounded-card">
                    <v-layout row wrap>
                      <v-flex xs12 sm3 md2>
                        <v-layout justify-space-around class="pl-3 ma-3">
                          <v-img
                            :src="props.item.avatar"
                            class="avatar-circle"
                            alt="gravatar"
                            contain
                            max-width="145px"
                          ></v-img>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-card-title primary-title>
                          <div>
                            <div class="headline text-truncate mb-1">
                              {{ props.item.firstname }}
                              {{ props.item.lastname }}
                              <v-tooltip right>
                                <v-icon
                                  slot="activator"
                                  class="mb-1"
                                  v-if="props.item.verifiedEmail"
                                  color="success"
                                  >check_circle</v-icon
                                >
                                <span
                                  >This members email address is verified</span
                                >
                              </v-tooltip>
                            </div>
                            <div class="text-truncate">
                              <span
                                class="grey--text subheading font-weight-light"
                              >
                                {{
                                  `${team.name}${
                                    isATeamOwner(props.item._id)
                                      ? ', Owner'
                                      : ''
                                  }`
                                }}
                              </span>
                            </div>
                            <div class="mb-3">
                              <v-btn
                                v-if="props.item.email"
                                icon
                                flat
                                class="ml-0 mr-0"
                                color="indigo"
                                :href="`mailto:${props.item.email}`"
                              >
                                <v-tooltip top>
                                  <v-icon slot="activator">email</v-icon>
                                  <span>{{ props.item.email }}</span>
                                </v-tooltip>
                              </v-btn>
                              <v-btn
                                v-if="props.item.mobile"
                                icon
                                flat
                                class="ml-0"
                                color="#00B8D4"
                                :href="`tel:${props.item.mobile}`"
                              >
                                <v-tooltip top>
                                  <v-icon slot="activator">phone</v-icon>
                                  <span>{{ props.item.mobile }}</span>
                                </v-tooltip>
                              </v-btn>
                            </div>
                            <div>{{ props.item.description }}</div>
                          </div>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                    <v-divider light></v-divider>
                    <v-card-actions class="pa-3 grey lighten-5">
                      <v-spacer></v-spacer>
                      <EditMember
                        v-if="isTeamOwner || isYou(props.item._id)"
                        :member="props.item"
                      ></EditMember>
                      <v-btn
                        v-if="
                          isTeamOwner &&
                            !isYou(props.item._id) &&
                            !isATeamOwner(props.item._id)
                        "
                        icon
                        flat
                        color="primary"
                        @click="deleteMember(props.item)"
                      >
                        <v-tooltip top>
                          <v-icon small slot="activator">delete</v-icon>
                          <span>Remove the member from this team</span>
                        </v-tooltip>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-card>
            </div>
          </template>
          <template v-slot:no-data>
            <span
              >No member data found... This doesn't make sense. Please try
              restarting your browser.</span
            >
          </template>
        </v-data-table>
        <div v-if="invitations && invitations.length > 0">
          <v-toolbar v-if="isTeamOwner" flat color="white">
            <v-toolbar-title class="mt-3"
              ><span class="primary--text text-lighten-2"
                >Outstanding Invitations </span
              ><span class="primary--text text-lighten-2 font-weight-thin"
                >({{ invitations.length }})</span
              ></v-toolbar-title
            >
          </v-toolbar>
          <v-data-table
            v-if="isTeamOwner"
            :headers="computedInviteHeaders"
            :items="invitations"
            class="ml-4 mr-4"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">
                {{ props.item.email }}
              </td>
              <td class="text-xs-right" v-if="!$vuetify.breakpoint.smAndDown">
                {{ getUserName(props.item.invitedBy) }}
              </td>
              <td class="text-xs-right" v-if="!$vuetify.breakpoint.smAndDown">
                {{ formatDate(props.item.createdAt) }}
              </td>
              <td class="justify-center layout px-0">
                <v-icon small @click="deleteInvite(props.item)" color="primary">
                  delete
                </v-icon>
              </td>
            </template>
            <template v-slot:no-data>
              <span>There are no open invitations at the moment.</span>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
// import moment from 'moment-timezone'
// import format from 'date-fns/format';
// import parseISO from 'date-fns/parseISO';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import Avatar from 'vue-avatar';
import Invite from './../components/Invite';
import EditMember from './../components/EditMember';

dayjs.extend(utc);
dayjs.extend(relativeTime);

const CARD_WIDTH = '550px';

export default {
  components: { Avatar, Invite, EditMember },
  avatarNav: 40, // non reactive way of setting options
  avatarTool: 28, // non reactive... access using $options
  data: function() {
    return {
      expand: false,
      loading: false,
      error: false,
      errorMessage: 'Error.',
      cardWidth: CARD_WIDTH,
      active: null,
      windowSize: {
        x: 0,
        y: 0
      },
      headers: [
        {
          text: 'Member',
          align: 'left',
          sortable: true,
          value: 'lastname'
        },
        { text: 'Email', value: 'email', align: 'right', hide: 'smAndDown' },
        { text: 'Mobile', value: 'mobile', align: 'right', hide: 'smAndDown' },
        {
          text: 'Last Login',
          value: 'login',
          align: 'right',
          sortable: true,
          hide: 'smAndDown'
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: '20',
          hide: 'smAndDown'
        }
      ],
      inviteHeaders: [
        {
          text: 'Invitee',
          align: 'left',
          sortable: true,
          value: 'email'
        },
        {
          text: 'Invited By',
          value: 'invitedBy',
          align: 'right',
          hide: 'smAndDown'
        },
        {
          text: 'Invited On',
          value: 'createdAt',
          align: 'right',
          sortable: true,
          hide: 'smAndDown'
        },
        { text: 'Actions', value: 'actions', sortable: false, width: '20' }
      ]
    };
  },
  computed: {
    ...mapGetters('auth', ['isTeamOwner']),
    ...mapState('auth', ['team', 'user', 'users', 'account']),
    ...mapState('account', ['invitations']),
    computedHeaders() {
      return this.headers.filter(
        h => !h.hide || !this.$vuetify.breakpoint[h.hide]
      );
    },
    computedInviteHeaders() {
      return this.inviteHeaders.filter(
        h => !h.hide || !this.$vuetify.breakpoint[h.hide]
      );
    },
    userCount() {
      const existingUsers = this.users.length;
      const userLimit = this.account.userLimit;
      return `(${existingUsers}/${userLimit})`;
    },
    ihasusers() {
      return this.users.length < this.account.userLimit;
    }
  },
  mounted: async function() {
    await this.getTeam();
    if (this.isTeamOwner) {
      this.getInvitations();
    }
    // this.onResize();
  },
  methods: {
    // onResize() {
    //   this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    //   console.log('window width:', this.windowSize.x);
    //   if (this.windowSize.x < 450) this.cardWidth = this.windowSize.x;
    // },
    isATeamOwner(userId) {
      if (userId) {
        return !!this.team.owners.includes(userId);
      }
      return false;
    },
    isYou(userId) {
      return userId === this.user._id;
    },
    async deleteInvite(invitation) {
      if (invitation && invitation._id) {
        const res = await this.$dialog.confirm({
          text: 'Are you sure you wish to delete this invitation?',
          title: 'Delete Invitation?',
          actions: {
            false: {
              text: 'Cancel',
              color: 'primary'
            },
            true: {
              text: 'Delete Invitation',
              color: 'accent'
            }
          }
        });
        if (res) {
          const result = await this.deleteInvitation(invitation._id);
          if (result && result.success) {
            this.setSnack(result.message);
          } else if (result && !result.success) {
            this.$dialog.error({
              text: result.message,
              title: 'Error'
            });
          }
        }
      }
    },
    getUserName(userId) {
      if (this.user._id === userId) {
        return 'You';
      }
      const user = this.users.find(function(user) {
        return user._id === userId;
      });
      if (user) {
        return this.makeName(user);
      }
    },
    async deleteMember(member) {
      if (member._id === this.user._id) {
        this.$dialog.error({
          text: `You can't remove yourself from a team. Only another owner of this team can remove you.`,
          title: 'Error'
        });
      } else {
        const res = await this.$dialog.confirm({
          text: 'Are you sure you wish to remove this member from your team?',
          title: 'Remove Member?',
          actions: {
            false: {
              text: 'Cancel',
              color: 'primary'
            },
            true: {
              text: 'Remove Member',
              color: 'accent'
            }
          }
        });
        if (res) {
          const result = await this.leaveTeam({
            teamId: this.team._id,
            userId: member._id
          });
          if (result && result.error) {
            this.$dialog.error({
              text: result.message,
              title: 'Error'
            });
          } else {
            this.setSnack('Member has been removed.');
          }
        }
      }
    },
    makeName(user) {
      const name = `${user.firstname} ${user.lastname}`.trim();
      if (name) {
        return name;
      }
      if (user.nickname) return user.nickname;
      return 'Unknown Mystery Person';
    },
    formatDate(date) {
      if (date) {
        return dayjs.utc(date).fromNow();
      }
      return '';
    },
    // formatLongDate(date) {
    //   if (date) {
    //     return format(parseISO(date), 'PPPPpppp');
    //   }
    //   return '';
    // },
    async updateNotice() {
      const res = await this.$dialog.confirm({
        text:
          'Your team is full. You need to upgrade to a larger account if you want to add more team members.',
        title: 'Account Limit Reached',
        actions: {
          false: {
            text: 'Cancel',
            color: 'primary'
          },
          true: {
            text: 'Find out more?',
            color: 'accent'
          }
        }
      });
      if (res) {
        this.$router.push('/account');
      }
    },
    ...mapActions({
      getTeam: 'auth/getTeam',
      sendInvitation: 'account/sendInvitation',
      deleteInvitation: 'account/deleteInvitation',
      getInvitations: 'account/getInvitations',
      leaveTeam: 'account/leaveTeam',
      // refreshToken: 'auth/fetch',
      setSnack: 'snackbar/setSnack'
    })
  }
};
</script>
<style>
/*tbody tr:nth-of-type(odd) {*/
/*  background-color: rgba(0, 0, 0, .04);*/
/*}*/
.rounded-card {
  border-radius: 10px;
}
.avatar-circle {
  border-radius: 50%;
}
</style>
